import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconSupport = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.03657 3.6001H18.2547C19.7158 3.6001 20.9002 4.78451 20.9002 6.24555V20.2092L20.8943 20.316C20.8129 21.0455 19.905 21.3868 19.3638 20.8456L16.1372 17.6181L6.03657 17.6183C4.57553 17.6183 3.39111 16.4339 3.39111 14.9728V6.24555C3.39111 4.78451 4.57553 3.6001 6.03657 3.6001ZM18.2547 5.4001H6.03657C5.56964 5.4001 5.19111 5.77862 5.19111 6.24555V14.9728C5.19111 15.4398 5.56964 15.8183 6.03657 15.8183H16.5093L16.6276 15.8261C16.8226 15.8519 17.005 15.9412 17.1457 16.0819L19.1012 18.0371L19.1002 6.24555C19.1002 5.77862 18.7217 5.4001 18.2547 5.4001ZM12.417 11.6301V11.8001H11.207V11.5101C11.207 10.6859 11.6484 10.247 12.0567 9.84093C12.1042 9.79372 12.1512 9.74696 12.197 9.7001C12.497 9.4101 12.737 9.1401 12.737 8.7801C12.737 8.3401 12.477 8.0301 11.927 8.0301C11.357 8.0301 10.997 8.4101 10.997 8.9701H9.78702C9.78702 7.6601 10.587 6.8501 11.957 6.8501C13.277 6.8501 13.977 7.6601 13.977 8.7301C13.977 9.4601 13.627 9.9001 13.257 10.2601C13.2115 10.3035 13.166 10.3458 13.121 10.3876C12.7509 10.7314 12.417 11.0416 12.417 11.6301ZM12.507 12.6101V14.0001H11.117V12.6101H12.507Z"
        />
      </svg>
    );
  }
);
